import { stripeCloudFunctionsApi } from "@docsndata/stripe-cloud-functions-api";
export async function createPaygCheckout(amount, currency, tenantId, environment, customerEmail, metadata) {
    const uri = stripeCloudFunctionsApi.v1.payg.checkout.post.uri.constructor(tenantId, environment);
    const body = stripeCloudFunctionsApi.v1.payg.checkout.post.body.create(amount, currency, customerEmail, metadata);
    const url = stripeCloudFunctionsApi.v1.fullyQualifiedUrl(uri);
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify(body)
    });
    const { clientSecret, publicKey } = await response.json();
    return { clientSecret, publicKey };
}
